import { useReducer } from 'react';
import reducer, { defaultState } from './reducer';
import logger from 'use-reducer-logger';
import * as actions from './actions';

export default function useGetPromoEvents() {

    const [state, dispatch] = useReducer(logger(reducer), defaultState);

    const fetch = actions.fetch(dispatch);

    return {
        state,
        fetch
    }
}
